import { Base_Importer } from '../Base/Base.ui.Importer'

const pageImporters = {
    Actn_ActionPage: () => import('../Actn/Actn.ui.ActionPage').then((i) => i.Actn_ActionPage),
    Actn_UserActionsPage: () => import('../Actn/Actn.ui.UserActionsPage').then((i) => i.Actn_UserActionsPage),
    Actn_NewAction: () => import('../Actn/Actn.ui.NewAction').then((i) => i.Actn_NewAction),
    Actn_EditAction: () => import('../Actn/Actn.ui.EditAction').then((i) => i.Actn_EditAction),
    Actn_ReportActionPage: () => import('../Actn/Actn.ui.ReportActionPage').then((i) => i.Actn_ReportActionPage),
    Acti_FlowExecutionPage: () => import('../Acti/Acti.ui.FlowExecutionPage').then((i) => i.Acti_FlowExecutionPage),
    Acti_ActivityPage: () => import('../Acti/Acti.ui.ActivityPage').then((i) => i.Acti_ActivityPage),
    PlannerApp: () => import('../../src/ui/planner/index').then((i) => i.default),
    Flow_ExecutionPage: () => import('../Flow/Flow.ui.ExecutionPage').then((i) => i.Flow_ExecutionPage),
    Flow_ActionExecutionPage: () =>
        import('../Flow/Flow.ui.ActionExecutionPage').then((i) => i.Flow_ActionExecutionPage),
    Guid_ExecutionPage: () => import('../Guid/Guid.ui.ExecutionPage').then((i) => i.Guid_ExecutionPage),
    Loca_OwnershipPage: () => import('../Loca/Loca.ui.OwnershipPage').then((i) => i.Loca_OwnershipPage),
    LocationApp: () => import('../../src/ui/location/index').then((i) => i.default),
    Note_NewNotePage: () => import('../Note/Note.ui.NewNotePage').then((i) => i.default),
    Note_NotebookPage: () => import('../Note/Note.ui.Notebook/NotebookPage').then((i) => i.default),
    Noti_NotificationsPage: () => import('../Noti/Noti.ui.NotificationsPage').then((i) => i.Noti_NotificationsPage),
    Post_TextPostFormNew: () => import('../Post/Post.ui.TextPostFormNew').then((i) => i.Post_TextPostFormNew),
    Post_TextPostFormEdit: () => import('../Post/Post.ui.TextPostFormEdit').then((i) => i.Post_TextPostFormEdit),
    Post_DetailPage: () => import('../Post/Post.ui.DetailPage').then((i) => i.Post_DetailPage),
    Proc_ContentPage: () => import('../Proc/Proc.ui.ContentPage').then((i) => i.Proc_ContentPage),
    ReportApp: () => import('../../src/ui/report/index').then((i) => i.default),
    Rpts_View: () => import('../Rpts/Rpts.ui.View').then((i) => i.Rpts_View),
    Srch_Page: () => import('../Srch/Srch.ui.Page').then((i) => i.Srch_Page),
    Sett_App: () => import('../Sett/Sett.ui.App').then((i) => i.Sett_App),
    SD_ViewSmartData: () => import('../SD/SD.ui.ViewSmartData').then((i) => i.SD_ViewSmartData),
    Todo_ToDoPage: () => import('../Todo/Todo.ui.ToDoPage').then((i) => i.Todo_ToDoPage),
    Todo_CurrentReportSummary: () =>
        import('../Todo/Todo.ui.CurrentReportSummary').then((i) => i.Todo_CurrentReportSummary),
    Todo_OpenFlowReportSummary: () =>
        import('../Todo/Todo.ui.OpenFlowReportSummary').then((i) => i.Todo_OpenFlowReportSummary),
    Todo_ScheduledReportSummary: () =>
        import('../Todo/Todo.ui.ScheduledReportSummary').then((i) => i.Todo_ScheduledReportSummary),
    Todo_AdHocReportStart: () => import('../Todo/Todo.ui.AdHocReportStart').then((i) => i.Todo_AdHocReportStart),
    Todo_AdHocReportSummary: () => import('../Todo/Todo.ui.AdHocReportSummary').then((i) => i.Todo_AdHocReportSummary),
    Todo_AdHocReportSubjectPicker: () =>
        import('../Todo/ToDo.ui.AdHocReportSubjectPicker').then((i) => i.Todo_AdHocReportSubjectPicker),
    Unit_ContentPage: () => import('../Unit/Unit.ui.ContentPage').then((i) => i.Unit_ContentPage),
    User_Page: () => import('../User/User.ui.ProfilePage').then((i) => i.User_ProfilePage),
    Gami_Leaderboard: () => import('../Gami/Gami.ui.Leaderboard').then((i) => i.Gami_Leaderboard),
    Invi_App: () => import('../Invi/Invi.ui.App').then((i) => i.Invi_App),
    UI_Playground: () => import('../UI/UI.Playground').then((i) => i.UI_Playground),
}

export const lazyPages = {
    Actn_ActionPage: Base_Importer(pageImporters.Actn_ActionPage),
    Actn_UserActionsPage: Base_Importer(pageImporters.Actn_UserActionsPage),
    Actn_NewAction: Base_Importer(pageImporters.Actn_NewAction),
    Actn_EditAction: Base_Importer(pageImporters.Actn_EditAction),
    Actn_ReportActionPage: Base_Importer(pageImporters.Actn_ReportActionPage),
    Acti_FlowExecutionPage: Base_Importer(pageImporters.Acti_FlowExecutionPage),
    Acti_ActivityPage: Base_Importer(pageImporters.Acti_ActivityPage),
    PlannerApp: Base_Importer(pageImporters.PlannerApp),
    Flow_ExecutionPage: Base_Importer(pageImporters.Flow_ExecutionPage),
    Flow_ActionExecutionPage: Base_Importer(pageImporters.Flow_ActionExecutionPage),
    Guid_ExecutionPage: Base_Importer(pageImporters.Guid_ExecutionPage),
    Loca_OwnershipPage: Base_Importer(pageImporters.Loca_OwnershipPage),
    LocationApp: Base_Importer(pageImporters.LocationApp),
    Note_NewNotePage: Base_Importer(pageImporters.Note_NewNotePage),
    Note_NotebookPage: Base_Importer(pageImporters.Note_NotebookPage),
    Noti_NotificationsPage: Base_Importer(pageImporters.Noti_NotificationsPage),
    Post_TextPostFormNew: Base_Importer(pageImporters.Post_TextPostFormNew),
    Post_TextPostFormEdit: Base_Importer(pageImporters.Post_TextPostFormEdit),
    Post_DetailPage: Base_Importer(pageImporters.Post_DetailPage),
    Proc_ContentPage: Base_Importer(pageImporters.Proc_ContentPage),
    ReportApp: Base_Importer(pageImporters.ReportApp),
    Rpts_View: Base_Importer(pageImporters.Rpts_View),
    Srch_Page: Base_Importer(pageImporters.Srch_Page),
    Sett_App: Base_Importer(pageImporters.Sett_App),
    SD_ViewSmartData: Base_Importer(pageImporters.SD_ViewSmartData),
    Todo_ToDoPage: Base_Importer(pageImporters.Todo_ToDoPage),
    Todo_CurrentReportSummary: Base_Importer(pageImporters.Todo_CurrentReportSummary),
    Todo_OpenFlowReportSummary: Base_Importer(pageImporters.Todo_OpenFlowReportSummary),
    Todo_ScheduledReportSummary: Base_Importer(pageImporters.Todo_ScheduledReportSummary),
    Todo_AdHocReportStart: Base_Importer(pageImporters.Todo_AdHocReportStart),
    Todo_AdHocReportSummary: Base_Importer(pageImporters.Todo_AdHocReportSummary),
    Todo_AdHocReportSubjectPicker: Base_Importer(pageImporters.Todo_AdHocReportSubjectPicker),
    Unit_ContentPage: Base_Importer(pageImporters.Unit_ContentPage),
    User_Page: Base_Importer(pageImporters.User_Page),
    Gami_Leaderboard: Base_Importer(pageImporters.Gami_Leaderboard),
    Invi_App: Base_Importer(pageImporters.Invi_App),
    UI_Playground: Base_Importer(pageImporters.UI_Playground),
}
